<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import EloadCampaignList from '@/views/pages/e-load/EloadCampaignList.vue';
  import { getModuleAccess } from '@/router/helper.js'

  import Moment from 'moment';
  import 'moment-timezone';
  import { extendMoment } from 'moment-range';

  const moment = extendMoment(Moment);

  /**
   * E-Load Topups component
   */
  export default {
    page: {
      title: "E-Load Topups",
    },
    components: {
      EloadCampaignList
    },
    data() {
      return {
        refreshKey: 0,
        title: "E-Load Topups",
        activeTab: 0,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        submitted: false,
        fieldsTopups: [
          {
            key: 'action',
            sortable: false,
            thStyle: { width: "15%" },
          },
          {
            key: 'skuName',
            sortable: true,
            label: 'SKU Name',
            thStyle: { width: "25%" },
          },
          {
            key: 'skuStatus',
            sortable: true,
            label: 'SKU Status',
            thStyle: { width: "20%" },
          },
          {
            key: 'amount',
            sortable: true,
            thStyle: { width: "20%" },
          },
          {
            key: 'defaultRebate',
            sortable: true,
            thStyle: { width: "20%" },
          },
        ],
        topupsItem: {
            id: null,
            topupName: "",
            topupAmount: "",
            topupRebate: ""
        },
        formExitChecker: {
            id: null,
            topupName: "",
            topupAmount: "",
            topupRebate: ""
        },
        sortingValue:{
          sort : "",
          orderDesc : "",
        },
        totalCount:0,
        currentTab:'sku',
        rangeOptions: {
          mode: "range",
        },
        lookupParams: {
          keyword: '',
          field: null,
          dateRange: ''
        },
        pagination: {
          rows: 10,
          page: 1,
          dateRange: '',
          sort: 'id',
          orderDesc: true
        },
        eloadTopupsModule: {
          access: {
            create: true,
            update: true,
            delete: true
          }
        }
      };
    },
    validations:{
      topupsItem:{
        topupName: {required},
        topupAmount: {required},
        topupRebate: {required},
      }
    },
    computed: {
      ...digitalLoadComputed,
      recordCount: {
        get(){
          if(this.activeTab == 0){
            return this.totalCount;
          } else if(this.activeTab == 1){
            return this.loadCampaignTotalRows;
          } else {
            return 0;
          }
        }
      },
    },
    mounted: async function() {
      if(location.hash == '#campaign'){
        this.activeTab = 1;
        this.changeTab('campaign');
      } else {
        this.activeTab = 0;
        this.changeTab('sku');
      }
      this.changeTitle({title: 'E-Load Topups'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'E-Load Topups', to: { name: 'E-Load Topups'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Topups')
      .then((access) => this.eloadTopupsModule.access = access);

    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      formattedRebate(item) {
        let rebateText = item.topupRebate + '%';
        if (item.scheduleDetails != null && item.scheduleDetails.length > 0) {
          
          for (let scheduled of JSON.parse(item.scheduleDetails)) {
            if (scheduled.isActive) {
              let existingDateRange = [moment(scheduled.startDate), moment(scheduled.endDate).add(1, 'day')];
              let currentDate = [moment(), moment()];

              let range1 = moment.range(existingDateRange);
              let range2 = moment.range(currentDate);

              if (range2.overlaps(range1)) {
                rebateText = `<span style="color: #E72F92; font-weight: 700; cursor:" v-b-tooltip.hover title="${scheduled.startDate} to ${scheduled.endDate} is on schedule!">${scheduled.rebate}%</span> (<span style="color: your-strike-text-color; text-decoration: line-through">${item.backupRebate}%</span>)`;
                break; // You can break the loop if an overlap is found
              }
            }
          }
        }
        return rebateText;
      },
      onExport(){
        this.$refs.campaignList.onExport();
      },
      getTopupsList() {
        var self = this;
        this.getLoadTopupsList({
          page: this.currentPage,
          rows: this.perPage
        }).then(function(){
          // console.log(">>>>>",self.loadTopupsTotalRows)
          self.totalCount = self.loadTopupsTotalRows
        })
      },
      createEloadTopups() {
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.topupsItem.$invalid){
          this.actionTopups({
            action: "create",
            body:{...this.topupsItem}
          })
          .then(() => {
            this.$alertify.success("Added Successfully");
            this.clearTopups()
            this.$bvModal.hide('bv-modal-create-topups')
            this.getTopupsList()
          })
          .catch(function(error) {
            this.$alertify.error(error);
            console.log(error);
            this.clearTopups()
            this.$bvModal.hide('bv-modal-create-topups')
          });
        }
      },
      updateEloadTopups() {
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.topupsItem.$invalid){
          this.actionTopups({
            action: "update",
            body:{
              id : this.topupsItem.id.toString(),
              topupAmount : this.topupsItem.topupAmount.toString(),
              topupName: this.topupsItem.topupName.toString(),
              topupRebate: this.topupsItem.topupRebate.toString(),
              backupRebate: this.topupsItem.backupRebate.toString()
            }
          })
          .then((response) => {
            console.log(response);
            this.$alertify.success("Updated Successfully");
            this.$bvModal.hide('bv-modal-update-topups')
            this.clearTopups()
            this.getTopupsList()
            return;
          })
          .catch(function(error) {
            console.log(error);
            this.$alertify.error(error);
            this.$bvModal.hide('bv-modal-update-topups')
            this.clearTopups()
            return;
          });
        }
      },
      async deleteEloadTopups(id,name) {
        if (!this.eloadTopupsModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a SKU.",
            "warning"
          );
        } else {
          //before swal add here the checking of campaign related to sku id
          Swal.fire({
              title: "Are you sure?",
              text: `Do you really want to delete ${name}? This process cannot be undone.`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes",
              cancelButtonText: 'No'
          }).then((result) => {
            if(result.isConfirmed) {
              this.actionTopups({
                action: "delete",
                body: {
                  id: id
                }
              }).then(() => {
                  // this.$alertify.success("Deleted Successfully");
                  Swal.fire("Delete Successful!", `SKU ${name} has been deleted.`,"success");
                  this.getTopupsList();
                
              })
              .catch((error) =>{
                Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                console.log(error);
              });
            } else {
              return;
            }
          })
        }
      },
      showUpdateModal(data){
        this.topupsItem = {
            id: data.topupId,
            topupName: data.topupName,
            topupAmount: data.topupAmount,
            topupRebate: data.topupRebate,
        }
        this.formExitChecker = {
            id: data.id,
            topupName: data.topupName,
            topupAmount: data.topupAmount,
            topupRebate: data.topupRebate,
        }
        this.$bvModal.show("bv-modal-update-topups")
      },
      clearTopups() {
          this.topupsItem = {
            id: null,
            topupName: "",
            topupAmount: "",
            topupRebate: ""
        }
          this.formExitChecker = {
            id: null,
            topupName: "",
            topupAmount: "",
            topupRebate: ""
        }
      },
      leaveform(modal){
          if(JSON.stringify(this.topupsItem) == JSON.stringify(this.formExitChecker)){
              this.$bvModal.hide(modal)
              this.clearTopups();
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.$bvModal.hide(modal)
                  this.clearTopups();
              }else{
                  return;
              }
          })
      },
      tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case "skuName" :
                column = 't.name';
                break;
            case 'amount' :
                column = 't.amount';
                break;
            case "defaultRebate" :
                column = 't.rebate';
                break;
            case "skuStatus" :
                column = 't.sku_status';
                break;
        }
        this.sortingValue.sort = column;
        this.sortingValue.orderDesc = action.sortDesc;
        console.log(this.sortingValue);   
        this.getLoadTopupsList({
          page: this.currentPage,
          ...this.sortingValue
        })     
        
      },
      changeTab(tab = "sku"){
        this.currentTab = tab;
        this.currentPage = 1;
        if(tab == "sku"){
          this.activeTab = 0;
          this.getTopupsList();
          this.totalCount = this.loadTopupsTotalRows
        } else if(tab == 'campaign'){
          this.activeTab = 1;
          this.$refs.campaignList.onRefresh();
        }
      },
      async updateSkuStatus(event){
        console.log(event);
        var action = (event["skuStatus"]? "Enable":"Disable");
        if(action == "Disable" && event["campaigns"] > 0){
          Swal.fire({
            title: action + " SKU Status",
            text: `On going campaign will be automatically set to Onhold and Disabled.`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Confirm",
          }).then((result) => {
            if (result.value) {
              // alert("update status");
              this.actionTopups({
                action: "update-sku-status",
                body:event
              })
              .then(() => {
                // this.$alertify.success(`${action} successfully.`);
                Swal.fire("Success!", `${action} successfully.`, "success");
                this.getTopupsList();
              })
              .catch(function(error) {
                this.$alertify.error(error);
              });
            }else{//return to its previous status when no is selected
              for(let x of this.loadTopupsList){
                if(x["topupId"] == event["topupId"]){
                  x["skuStatus"] = !event["skuStatus"]
                }
              }
            }
          });
        }else{
          this.actionTopups({
            action: "update-sku-status",
            body:event
          })
          .then(() => {
            // this.$alertify.success(`${action} successfully.`);
            Swal.fire("Success!", `${action} successfully.`, "success");
            this.getTopupsList();
          })
          .catch(function(error) {
            this.$alertify.error(error);
          });
        }
      },
      updateSkuDetails(item){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load sku", params: { id: item.topupId }
          }
        );
      },
      onDisplayChange(){
        if(this.currentTab == "sku"){
          if(
            (this.loadTopupsList.length < this.totalCount && this.loadTopupsList.length != this.perPage) || // condition for incrementing display per page
            (this.loadTopupsList.length == this.totalCount && this.perPage < this.loadTopupsList.length) // condition for decreasing display per page
            ){
            this.currentPage=1;
            this.changeTab();
          }
        }else{
          console.log("campaign");
        }
      },
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-3 col-sm-4">
                <div class="mt-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{recordCount}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-9 col-sm-8"> 

                 <div class="d-flex justify-content-end">
                  <div class="me-2" v-if="eloadTopupsModule.access.create">
                    <router-link :to="{ name: 'E-Load sku', params: { id: 0 }}" class="tc-white">
                      <button class="btn btn-primary" >
                          <i class="uil uil-plus me-1"></i>E-Load SKU
                      </button>
                    </router-link>
                    <b-button v-b-modal.bv-modal-create-topups variant="primary" v-if="false"><i class="uil uil-plus me-1"></i> Add E-Load SKU</b-button>
                  </div>
                  <div class="me-2" v-if="eloadTopupsModule.access.create">
                    <router-link :to="{ name: 'E-Load Campaign', params: { campaignId: 0, mode: 'add' }}">
                      <b-button variant="primary"><i class="uil uil-plus me-1"></i>E-Load Campaign</b-button>
                    </router-link>
                  </div>
                  <div class="me-2">
                    <b-form-group label="">
                      <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                        <i class='uil uil-export me-1'></i> Export
                      </b-button>
                    </b-form-group>
                  </div>
                  <div>
                    <a class="btn btn-secondary" @click="changeTab(currentTab)"
                      ><feather
                        type="refresh-ccw"
                        size="16"
                        class="icon nav-icon"
                      ></feather
                      >&nbsp;&nbsp; Refresh</a
                    >
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <!-- end table responsive -->

            <!--start of tab-->
              <b-tabs
                v-model="activeTab"
                content-class="p-3 text-muted"
                nav-class="nav-tabs-custom"
              >
                <b-tab class="border-0" @click="changeTab('sku')"><!-- tab of Eload sku-->
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">E-Load SKU</span>
                  </template>
                  <!-- table responsive -->
                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table
                        :items="loadTopupsList"
                        :fields="fieldsTopups"
                        responsive="sm"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="tableSorting"
                      >

                        <template #cell(action)="data">
                          <div class="d-flex">
                            <div class="btn-group me-2 mb-2 mb-sm-0">
                              <!-- showUpdateModal -->
                              <button type="button" class="btn btn-sm btn-primary" @click="updateSkuDetails(data.item)">
                                <i class="bx bx-edit bx-xs bx-fw"></i>
                              </button>
                            </div>

                            <!-- <b-button v-if="data.item.is_deletable == 0"
                                id="show-btn"
                                class="btn btn-sm btn-danger"
                                @click="deleteEloadTopups(data.item.topupId, data.item.topupName)"
                                ><i class="bx bx-trash bx-xs bx-fw"></i
                              ></b-button>
                            <b-button v-else
                                id="show-btn" 
                                class="btn btn-sm btn-danger" disabled 
                                ><i class="bx bx-trash bx-xs bx-fw"></i
                              ></b-button> -->
                              <b-button :disabled="data.item.is_deletable != 0"
                                id="show-btn"
                                class="btn btn-sm btn-danger"
                                @click="deleteEloadTopups(data.item.topupId, data.item.topupName)"
                                ><i class="bx bx-trash bx-xs bx-fw"></i
                              ></b-button>
                          </div>
                        </template>
                        <template #cell(skuName)="data">
                          <span>{{data.item.topupName}}</span>
                        </template>
                        <template #cell(skuStatus)="data">
                          <div class="form-check form-switch">
                              <label class="form-check-label" for="flexSwitchCheckDefault">{{data.item.skuStatus == 1?"Enable":"Disable"}}</label>
                              <input
                                  :disabled="!eloadTopupsModule.access.update"
                                  class="form-check-input"
                                  v-model="data.item.skuStatus"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  @change="updateSkuStatus(data.item)"
                              />
                          </div>
                        </template>
                        <template #cell(amount)="data">
                          <span>{{data.item.topupAmount | toCurrency}} </span>
                        </template>
                        <template #cell(defaultRebate)="data">
                          <span v-html="formattedRebate(data.item)"></span>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <!-- end table responsive -->
                  <div class="row g-0 text-center" v-if="loadTopupsTotalRows == 0">
                    <span>No data to display.</span>
                  </div>
                  <!-- pagination -->
                  <div class="row g-0 text-center text-sm-start" v-if="loadTopupsTotalRows != 0  && loadTopupsTotalRows > 10">
                    <!-- end col -->
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col">
                          <div class="form-group row pull-left">
                            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                            <div class="col-sm-6">
                              <b-form-group label-for="display-record">
                                <b-form-select class="form-select shadow-none w-fit"
                                  id="display-record"
                                  v-model="perPage"
                                  :options="pageOptions"
                                  @change="onDisplayChange()"
                                ></b-form-select>
                              </b-form-group>
                            </div>
                          </div>
                          <div
                            class="
                              dataTables_paginate
                              paging_simple_numbers
                              float-end
                            "
                          >
                            <b-pagination
                              class="pagination-rounded"
                              v-model="currentPage"
                              @input="getTopupsList()"
                              :total-rows="loadTopupsTotalRows"
                              :per-page="perPage"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col -->
                  </div>
                  <!-- end pagination -->
                </b-tab><!-- end of Eload sku-->
                <b-tab :active="currentTab == 'campaign'" @click="changeTab('campaign')"><!--tab of running campaign-->
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Running Campaign</span>
                  </template>
                  <eload-campaign-list ref="campaignList" :key="refreshKey" />
                </b-tab><!--end of running campaign-->
              </b-tabs>
            <!--end of tab-->

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- Create E-Load Topups -->
    <b-modal id="bv-modal-create-topups" title="Add E-Load Topups" @hidden="clearTopups()" size="md" hide-footer hide-header-close>
    
      <form class="px-4 py-3" @submit.prevent="createEloadTopups()">

        <div class="mb-3">
          <label class="form-label"
            >Topups Name<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupName"
            placeholder="Enter Topup Name"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupName.$error,
            }"
        
          />
        </div>
        <div class="mb-3">
          <label class="form-label"
            >Amount<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupAmount"
            placeholder="0.00"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupAmount.$error,
            }"
        
          />
        </div>
        <div class="mb-3">
          <label class="form-label"
            >Rebate<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupRebate"
            placeholder="0.00"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupRebate.$error,
            }"
        
          />
        </div>
        <div class="text-end mt-4">
          <b-button
            variant="light"
            class="w-sm"
            @click="leaveform('bv-modal-create-topups')"
            >Close</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            class="w-sm ms-2"

            >Add</b-button
          >
        </div>
      </form>

    </b-modal>

    <!-- Update E-Load Topups -->
    <b-modal id="bv-modal-update-topups" title="Add E-Load Topups" size="md" @hidden="clearTopups()" hide-footer hide-header-close>
    
      <form class="px-4 py-3" @submit.prevent="updateEloadTopups()">


        <div class="mb-3">
          <label class="form-label"
            >Topups Name<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupName"
            placeholder="Enter Topup Name"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupName.$error,
            }"
        
          />
        </div>
        <div class="mb-3">
          <label class="form-label"
            >Amount<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupAmount"
            placeholder="0.00"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupAmount.$error,
            }"
        
          />
        </div>
        <div class="mb-3">
          <label class="form-label"
            >Rebate<span style="color: red">*</span></label
          >
          <input
            type="text"
            class="form-control"
            v-model="topupsItem.topupRebate"
            placeholder="0.00"
            :class="{
              'is-invalid':
                submitted && $v.topupsItem.topupRebate.$error,
            }"
        
          />
        </div>
          
        <div class="text-end mt-4">
          <b-button
            variant="light"
            class="w-sm"
            @click="leaveform('bv-modal-update-topups')"
            >Close</b-button
          >
          <b-button
            type="submit"
            variant="primary"
            class="w-sm ms-2"
            >Update</b-button
          >
        </div>
      </form>

    </b-modal>
    <!-- end row -->
  </div>
</template>